export default {
  handleCatch(dispatch, commit, error, state, isUserAuthNeeded = false) {
    if (error?.message.toLowerCase().includes('cancel')) {
      return;
    }
    const statusCode = parseInt(error?.message.split(" ").pop());
    if ((!isUserAuthNeeded && statusCode === 500) || statusCode === 404 || statusCode === 409 || statusCode === 400 || (!isUserAuthNeeded && statusCode === 302)) {
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state?.errorMsg ? state.errorMsg : "Error",
          description: state?.basketCommonErrorMsg
        },
        { root: true }
      );
      commit("updateLoader", false);
    } else if (isUserAuthNeeded) {
      commit("updateLoader", true);
      var route = window?.location?.href;
      var urlObject = new URL(route);
      var rootUrl = urlObject?.origin;
      var urlAfterHost = route?.split(rootUrl)[1];
      window.location.href = `/Account/SignUpOrSignIn?returnUrl=${urlAfterHost}`;
    }
    else {
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state?.errorMsg ? state.errorMsg : "Error",
          description: state?.basketCommonErrorMsg
        },
        { root: true }
      );
      commit("updateLoader", false);
    }
  },

  fallBackURL(data) {
    var route = window?.location?.href;
    var urlObject = new URL(route);
    var rootUrl = urlObject?.origin;
    var urlAfterHost = route?.split(rootUrl)[1];
    if (urlAfterHost.indexOf('?') !== -1) {
      urlAfterHost += `&openModal=${data}`;
    } else {
      urlAfterHost += `?openModal=${data}`;
    }
    window.location.href = `/Account/SignUpOrSignIn?returnUrl=${encodeURIComponent(urlAfterHost)}`;
  },

  removeQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const modalParameterValues = ['webpage', 'gallery', 'gallery-pdp', 'pdp-modal'];

    modalParameterValues.forEach(value => {
      if (urlParams.has('openModal') && urlParams.get('openModal') === value) {
        urlParams.delete('openModal');
      }
    });

    // Construct updated search params string
    const searchParamsString = urlParams.toString();

    // Construct updated URL
    const hash = window.location.hash;
    const updatedUrl = searchParamsString ? `${window.location.pathname}?${searchParamsString}${hash}` : `${window.location.pathname}${hash}`;

    // Update the URL
    window.history.replaceState('', 'webpage', updatedUrl);

  },

  processHeading(heading) {
    if (!heading) {
      return { underlinedPart: '', remainingText: '' };
    }
    heading = heading?.trim();

    // Split the heading into parts
    const words = heading?.split(' ');
    const firstWord = words[0];
    const remainingText = words?.slice(1)?.join(' ');

    let partToUnderline = '';
    let remainingPart = '';

    // Determine what to underline and how to handle the remaining text
    if (firstWord.length > 3) {
        partToUnderline = firstWord?.substring(0, 3);
        remainingPart = firstWord?.substring(3) + ' ' + remainingText;
    } else {
        partToUnderline = firstWord;
        remainingPart = ' ' + remainingText;
    }

    return { underlinedPart: partToUnderline, remainingText: remainingPart };
  }


}
